// extracted by mini-css-extract-plugin
export default {"legend":"Health-legend-aUEiW","loading":"Health-loading-qxbW3 LoadingIndicator-loading-DWfav","status":"Health-status-QbfEq","healthOk":"Health-healthOk-mf6pA"};